import script from "./special-date.vue?vue&type=script&lang=ts&setup=true"
export * from "./special-date.vue?vue&type=script&lang=ts&setup=true"

import "./special-date.vue?vue&type=style&index=0&id=3170ec8e&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3170ec8e"]])

export default __exports__